// src/hooks/useModelesAccueil.ts — SCE Issues
// Les modèles d'accueil de /admin (lot 6 du chantier du 03/11) : lus une fois par
// session, seulement pour qui a un accueil personnalisable ; après un
// enregistrement dans /admin, la nouvelle version est diffusée tout de suite.
// En attendant la lecture (ou si elle échoue) : les modèles du code.

import { useEffect, useState } from 'react'
import { lireModeles } from '@/api/modelesAccueil.api'
import type { ModelesEnregistres } from '@/utils/dispositionAccueil'

let promesse: Promise<ModelesEnregistres> | null = null
let derniers: ModelesEnregistres | null = null
const abonnes = new Set<(m: ModelesEnregistres) => void>()

function charger(): Promise<ModelesEnregistres> {
  promesse ??= lireModeles()
    .catch(() => ({}))
    .then((m) => {
      derniers = m
      return m
    })
  return promesse
}

/** Après une écriture dans /admin : la nouvelle version, partout. */
export function publierModeles(m: ModelesEnregistres): void {
  promesse = Promise.resolve(m)
  derniers = m
  for (const f of abonnes) f(m)
}

/** @param actif faux : rien n'est lu, les modèles du code (accueil personnalisable fermé). */
export function useModelesAccueil(actif: boolean): { modeles: ModelesEnregistres; charge: boolean } {
  const [modeles, setModeles] = useState<ModelesEnregistres | null>(derniers)
  useEffect(() => {
    if (!actif) return
    let vivant = true
    void charger().then((m) => {
      if (vivant) setModeles(m)
    })
    const abonne = (m: ModelesEnregistres): void => setModeles(m)
    abonnes.add(abonne)
    return () => {
      vivant = false
      abonnes.delete(abonne)
    }
  }, [actif])
  return { modeles: actif ? (modeles ?? {}) : {}, charge: !actif || modeles !== null }
}
